<template>
  <b-container>
    <b-row>
      <b-col cols="12" lg="6" offset-lg="3">
        <VenueSearch />
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div v-if="!error">
          <item v-for="item in items" :key="item.id" :item="item" :latitude="latitude" :longitude="longitude"/>
          <div class="empty-list" v-if="actuallyNoResults">
            <h1> No Items </h1>
            <h4> Use search above to start adding items!</h4>
          </div>
        </div>
        <div v-else class="error-message">
          <h4>{{errorMessage}}</h4>
          <b-button variant="outline-danger" @click="getVenues">Try Again</b-button>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  import VenueSearch from './VenueSearch'
  import Item from './Item'
  import { db } from '@/firebase/db';
  import *  as geohash from 'ngeohash';

  export default {
    name: 'venue-list',
    components: {
      VenueSearch,
      Item
    },
    data: function() {
      return {
        items: [],
        error: null,
        defaultError: "Error grabbing items",
        errorMessage: null,
        loading: true,
        latitude: null,
        longitude: null,
      }
    },
    methods: {
      geohashDiff(position) {
        // Default precision is 9 which is about 15ft x 15ft
        const curGeohash = geohash.encode(this.latitude, this.longitude, 8);
        const nextGeohash = geohash.encode(position.coords.latitude, position.coords.longitude, 8);
        return curGeohash != nextGeohash;
      },
      latLngChanged(lat, lng) {
        return this.latitude != lat || this.longitude != lng;
      },
      setPosition(position) {

        if (position.coords.latitude && position.coords.longitude) {
          if (this.geohashDiff(position)) {
            this.latitude = position.coords.latitude
            this.longitude = position.coords.longitude
          }
        }
      },
      positionError(err) {
        console.log(err);
      }
    },
    computed: {
      actuallyNoResults: function() {
        return this.items && this.items.length == 0 && !this.loading && this.error == null;
      },
    },
    firestore: {
        items: db.collection('venues')
          .orderBy('visited')
          .orderBy('created', 'desc')
    },
    mounted() {
      if (navigator && navigator.permissions) {
        navigator.permissions.query({name:'geolocation'}).then((permissionStatus) => {
          permissionStatus.onchange = () => {
            if (this.state === 'granted') {
              navigator.geolocation.getCurrentPosition(this.setPosition, this.positionError);
            }
          };
        });
      }
      navigator.geolocation.getCurrentPosition(this.setPosition, this.positionError, { enableHighAccuracy: true, timeout: 10000, maximumAge: 30000 });
      navigator.geolocation.watchPosition(this.setPosition, this.positionError);
    }
  }
</script>

<style lang="scss" scoped>

  .error-message {
    color: var(--danger);
    padding: 20px 0;
    text-align: center;
    display: flex;
    flex-direction: column;
    width: 100%;
    align-items: center;
  }

  .empty-list {
    // text-shadow: 1px 1px 5px #000; // Maybe...
    padding-top: 50px;
    text-align: center;
    color: #fff;
  }

</style>
